// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../background9.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Login_loginContainer__L6V3O {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  background-color: #252525;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-size: 760px 760px;
  background-repeat: repeat;
  background-attachment: local;
}

.Login_loginCard__sVKak {
  background-color: rgba(24, 26, 27, 0.95);
  border-radius: 12px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.8);
  padding: 3rem;
  width: 100%;
  max-width: 420px;
  color: white;
  border: 1px solid rgba(255, 255, 255, 0.1);
}

.Login_loginCard__sVKak h2 {
  margin-bottom: 2rem;
  text-align: center;
  font-size: 2.2rem;
  color: #ffffff;
  font-weight: 600;
}

.Login_formGroup__y0Gvq {
  margin-bottom: 1.8rem;
}

.Login_formGroup__y0Gvq label {
  display: block;
  margin-bottom: 0.8rem;
  font-weight: 600;
  font-size: 0.95rem;
  color: #e0e0e0;
}

.Login_formGroup__y0Gvq input {
  width: 100%;
  padding: 1rem;
  border: 2px solid #444;
  border-radius: 8px;
  background-color: #2a2a2a;
  color: white;
  font-size: 1rem;
  transition: all 0.3s ease;
  box-sizing: border-box;
}

.Login_formGroup__y0Gvq input:focus {
  outline: none;
  border-color: #4a9eff;
  background-color: #333;
  box-shadow: 0 0 0 3px rgba(74, 158, 255, 0.1);
}

.Login_loginButton__cxu2J {
  width: 100%;
  padding: 1rem;
  background: linear-gradient(135deg, #4a9eff, #3a8aff);
  color: white;
  border: none;
  border-radius: 8px;
  font-size: 1.1rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  margin-top: 1rem;
  box-shadow: 0 4px 15px rgba(74, 158, 255, 0.3);
}

.Login_loginButton__cxu2J:hover {
  background: linear-gradient(135deg, #3a8aff, #2a7aff);
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(74, 158, 255, 0.4);
}

.Login_loginButton__cxu2J:active {
  transform: translateY(0);
}

.Login_errorMessage__bkVMY {
  background-color: rgba(255, 52, 52, 0.15);
  border: 1px solid rgba(255, 52, 52, 0.3);
  border-left: 4px solid #ff3434;
  color: #ff6b6b;
  padding: 1rem;
  margin-bottom: 1.5rem;
  border-radius: 8px;
  font-size: 0.9rem;
  backdrop-filter: blur(10px);
}

.Login_loadingSpinner__ZkWmo {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100vh;
  color: white;
  background-color: #252525;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-size: 760px 760px;
  background-repeat: repeat;
  background-attachment: local;
}

.Login_spinner__BHrtF {
  border: 4px solid rgba(255, 255, 255, 0.1);
  border-radius: 50%;
  border-top: 4px solid #4a9eff;
  width: 50px;
  height: 50px;
  animation: Login_spin__7xS\\+N 1s linear infinite;
  margin-bottom: 1.5rem;
}

@keyframes Login_spin__7xS\\+N {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

/* Add some responsive design */
@media (max-width: 480px) {
  .Login_loginCard__sVKak {
    margin: 1rem;
    padding: 2rem;
  }
  
  .Login_loginCard__sVKak h2 {
    font-size: 1.8rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Login.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;EACjB,yBAAyB;EACzB,yDAA2C;EAC3C,4BAA4B;EAC5B,yBAAyB;EACzB,4BAA4B;AAC9B;;AAEA;EACE,wCAAwC;EACxC,mBAAmB;EACnB,yCAAyC;EACzC,aAAa;EACb,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,0CAA0C;AAC5C;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,yBAAyB;EACzB,YAAY;EACZ,eAAe;EACf,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,sBAAsB;EACtB,6CAA6C;AAC/C;;AAEA;EACE,WAAW;EACX,aAAa;EACb,qDAAqD;EACrD,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,gBAAgB;EAChB,8CAA8C;AAChD;;AAEA;EACE,qDAAqD;EACrD,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,yCAAyC;EACzC,wCAAwC;EACxC,8BAA8B;EAC9B,cAAc;EACd,aAAa;EACb,qBAAqB;EACrB,kBAAkB;EAClB,iBAAiB;EACjB,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,YAAY;EACZ,yBAAyB;EACzB,yDAA2C;EAC3C,4BAA4B;EAC5B,yBAAyB;EACzB,4BAA4B;AAC9B;;AAEA;EACE,0CAA0C;EAC1C,kBAAkB;EAClB,6BAA6B;EAC7B,WAAW;EACX,YAAY;EACZ,gDAAkC;EAClC,qBAAqB;AACvB;;AAEA;EACE,KAAK,uBAAuB,EAAE;EAC9B,OAAO,yBAAyB,EAAE;AACpC;;AAEA,+BAA+B;AAC/B;EACE;IACE,YAAY;IACZ,aAAa;EACf;;EAEA;IACE,iBAAiB;EACnB;AACF","sourcesContent":[".loginContainer {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  min-height: 100vh;\n  background-color: #252525;\n  background-image: url('../background9.png');\n  background-size: 760px 760px;\n  background-repeat: repeat;\n  background-attachment: local;\n}\n\n.loginCard {\n  background-color: rgba(24, 26, 27, 0.95);\n  border-radius: 12px;\n  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.8);\n  padding: 3rem;\n  width: 100%;\n  max-width: 420px;\n  color: white;\n  border: 1px solid rgba(255, 255, 255, 0.1);\n}\n\n.loginCard h2 {\n  margin-bottom: 2rem;\n  text-align: center;\n  font-size: 2.2rem;\n  color: #ffffff;\n  font-weight: 600;\n}\n\n.formGroup {\n  margin-bottom: 1.8rem;\n}\n\n.formGroup label {\n  display: block;\n  margin-bottom: 0.8rem;\n  font-weight: 600;\n  font-size: 0.95rem;\n  color: #e0e0e0;\n}\n\n.formGroup input {\n  width: 100%;\n  padding: 1rem;\n  border: 2px solid #444;\n  border-radius: 8px;\n  background-color: #2a2a2a;\n  color: white;\n  font-size: 1rem;\n  transition: all 0.3s ease;\n  box-sizing: border-box;\n}\n\n.formGroup input:focus {\n  outline: none;\n  border-color: #4a9eff;\n  background-color: #333;\n  box-shadow: 0 0 0 3px rgba(74, 158, 255, 0.1);\n}\n\n.loginButton {\n  width: 100%;\n  padding: 1rem;\n  background: linear-gradient(135deg, #4a9eff, #3a8aff);\n  color: white;\n  border: none;\n  border-radius: 8px;\n  font-size: 1.1rem;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  margin-top: 1rem;\n  box-shadow: 0 4px 15px rgba(74, 158, 255, 0.3);\n}\n\n.loginButton:hover {\n  background: linear-gradient(135deg, #3a8aff, #2a7aff);\n  transform: translateY(-2px);\n  box-shadow: 0 6px 20px rgba(74, 158, 255, 0.4);\n}\n\n.loginButton:active {\n  transform: translateY(0);\n}\n\n.errorMessage {\n  background-color: rgba(255, 52, 52, 0.15);\n  border: 1px solid rgba(255, 52, 52, 0.3);\n  border-left: 4px solid #ff3434;\n  color: #ff6b6b;\n  padding: 1rem;\n  margin-bottom: 1.5rem;\n  border-radius: 8px;\n  font-size: 0.9rem;\n  backdrop-filter: blur(10px);\n}\n\n.loadingSpinner {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  height: 100vh;\n  color: white;\n  background-color: #252525;\n  background-image: url('../background9.png');\n  background-size: 760px 760px;\n  background-repeat: repeat;\n  background-attachment: local;\n}\n\n.spinner {\n  border: 4px solid rgba(255, 255, 255, 0.1);\n  border-radius: 50%;\n  border-top: 4px solid #4a9eff;\n  width: 50px;\n  height: 50px;\n  animation: spin 1s linear infinite;\n  margin-bottom: 1.5rem;\n}\n\n@keyframes spin {\n  0% { transform: rotate(0deg); }\n  100% { transform: rotate(360deg); }\n}\n\n/* Add some responsive design */\n@media (max-width: 480px) {\n  .loginCard {\n    margin: 1rem;\n    padding: 2rem;\n  }\n  \n  .loginCard h2 {\n    font-size: 1.8rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"loginContainer": `Login_loginContainer__L6V3O`,
	"loginCard": `Login_loginCard__sVKak`,
	"formGroup": `Login_formGroup__y0Gvq`,
	"loginButton": `Login_loginButton__cxu2J`,
	"errorMessage": `Login_errorMessage__bkVMY`,
	"loadingSpinner": `Login_loadingSpinner__ZkWmo`,
	"spinner": `Login_spinner__BHrtF`,
	"spin": `Login_spin__7xS+N`
};
export default ___CSS_LOADER_EXPORT___;
